import Table from '../../table/Table';
import AlertStatusHeader from './AlertStatusHeader';
import AlertStatusRow from './AlertStatusRow';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { sortStatuses } from './alertStatusesActions';
import immUpdate from 'immutability-helper';
import { InternalApiAlertType, InternalApiScreeningAlertStatus } from '../../api-internal';

interface Props {
  type: InternalApiAlertType;
  allStatuses: InternalApiScreeningAlertStatus[];
  showingHistoric: boolean;
  showingAllAtOnce: boolean;
}

const AlertStatusTable = ({ type, allStatuses, showingAllAtOnce, showingHistoric }: Props) => {
  const dispatch = useDispatch();

  const [activeStatuses, setActiveStatuses] = useState<InternalApiScreeningAlertStatus[]>(allStatuses);
  useEffect(() => {
    setActiveStatuses(allStatuses);
  }, [allStatuses]);

  const updateSortOrder = async () => {
    dispatch(sortStatuses(type, activeStatuses));
  };

  const moveStatus = (dragIndex: number, hoverIndex: number) => {
    const status = activeStatuses[dragIndex];
    const newStatuses = immUpdate(activeStatuses, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, status],
      ],
    });
    setActiveStatuses(newStatuses);
  };

  const isDraggable = !showingHistoric && showingAllAtOnce;

  return (
    <>
      <Table
        hover={false}
        total={activeStatuses?.length || 0}
        page={0}
        size={activeStatuses?.length || 0}
        items={activeStatuses || []}
        fetchPage={() => {
          // empty
        }}
        header={() => <AlertStatusHeader isHistoric={showingHistoric} isDraggable={isDraggable} />}
        showBorders={true}
        body={(shownStatuses) =>
          shownStatuses?.length > 0 &&
          shownStatuses.map((status, index) => (
            <AlertStatusRow
              key={status.id}
              status={status}
              type={type}
              isDraggable={isDraggable}
              isHistoric={showingHistoric}
              index={index}
              moveStatus={moveStatus}
              updateSortOrder={updateSortOrder}
            />
          ))
        }
      />
    </>
  );
};

export default AlertStatusTable;
